<template>
  <div id="real-time-monitoring">
    <vessel-list
      :onActive="onActiveVesselList"
      :isActive="isActiveVesselList"
    />
    <VesselHistory
      :callback="searchVesselHistory"
      :onChangeValue="onChangeValue"
      :max="vesselHistoryData.length - 1"
      :onCloseHistory="onCloseHistory"
      :onLoadHistory="onLoadHistory"
      :map="warpMap"
      :onActive="onActiveVesselHistory"
      :onFullScreen="onFullScreen"
      :isActive="isActivevesselHistory"
    />
    <base-station
      :isActive="activeBaseStation"
      :handleSelectedBaseStation="handleSelectedBaseStation"
      :onActive="onActiveBaseStation"
      :onClose="onCloseBaseStation"
    />
    <!-- ปุ่มรายการเรื่อ ในโครงการ Excise tankers ของ admin -->
    <vx-tooltip
      :class="
        userRole == 'ROLE_SYSADMIN' || userRole == 'ROLE_ADMIN'
          ? 'customizer-btn-listExcise'
          : 'customizer-btn-listExcise-user'
      "
      text="Excise tanker"
      position="left"
    >
      <vs-button
        v-if="collapsed"
        color="warning"
        icon-pack="feather"
        icon="icon-chevrons-left"
        style="border-top-right-radius: 0; border-bottom-right-radius: 0"
        @click="setCollapsed(false)"
      ></vs-button>
      <vs-button
        v-else
        id="button-with-loading"
        ref="loadableButton"
        class="vs-con-loading__container mb-3"
        color="primary"
        icon-pack="feather"
        icon="icon-anchor"
        type="filled"
        style="border-top-right-radius: 0px; border-bottom-right-radius: 0px"
        @click="onActiveExciseTanker"
      ></vs-button>
    </vx-tooltip>
    <!-- สิ้นสุด ปุ่มรายการเรื่อ ในโครงการ Excise tankers ของ user -->
    <!-- ปุ่มวาดเส้น ของ admin -->
    <vx-tooltip
      class="customizer-btn-drawingMap"
      text="Draw Manager"
      position="left"
    >
      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-edit"
        type="filled"
        style="border-top-right-radius: 0px; border-bottom-right-radius: 0px"
        @click="onActiveDrawer"
      ></vs-button>
    </vx-tooltip>
    <!-- สิ้นสุด ปุ่มรายการเรื่อ รายการสถานี Base station ของ admin -->
    <!-- เเถบ silde วาดเส้นด้านซ้าย -->
    <div id="parentx-demo-6">
      <vs-sidebar
        :reduce="reduce"
        v-model="activeDraw"
        :click-not-close="true"
        :hidden-background="true"
        :reduce-not-hover-expand="notExpand"
        default-index="2"
        parent="#parentx-demo-2"
        color="success"
        class="sidebarx"
        spacer
      >
        <vx-tooltip
          style="margin-left: 7px; padding: 2px"
          text="Polygon"
          position="right"
        >
          <vs-button
            :color="selectedDrawing == 'Polygon' ? 'dark' : 'primary'"
            type="filled"
            icon-pack="feather"
            icon="icon-alert-octagon"
            @click="draw('Polygon')"
          ></vs-button>
        </vx-tooltip>
        <vx-tooltip
          style="margin-left: 7px; padding: 2px"
          text="Circle"
          position="right"
        >
          <vs-button
            :color="selectedDrawing == 'Circle' ? 'dark' : 'primary'"
            type="filled"
            icon-pack="feather"
            icon="icon-circle"
            @click="draw('Circle')"
          ></vs-button>
        </vx-tooltip>
        <vx-tooltip
          style="margin-left: 7px; padding: 2px"
          text="Polyline"
          position="right"
        >
          <vs-button
            :color="selectedDrawing == 'PolyLine' ? 'dark' : 'primary'"
            type="filled"
            icon-pack="feather"
            icon="icon-minus"
            @click="draw('PolyLine')"
          ></vs-button>
        </vx-tooltip>
        <vx-tooltip
          style="margin-left: 7px; padding: 2px"
          text="Rectangle"
          position="right"
        >
          <vs-button
            :color="selectedDrawing == 'Rectangle' ? 'dark' : 'primary'"
            type="filled"
            icon-pack="feather"
            icon="icon-copy"
            @click="draw('Rectangle')"
          ></vs-button>
        </vx-tooltip>
        <div id="color-palette"></div>
        <div>
          <vx-tooltip
            class="customizer-btn-color-delete"
            style="margin-bottom: 55px"
            text="Delete Zone"
            position="right"
          >
            <vs-button
              id="delete-button"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              type="filled"
              @click="deleteSelectedShape()"
            ></vs-button>
          </vx-tooltip>
        </div>
        <br />
        <div>
          <vx-tooltip
            class="customizer-btn-color-delete"
            text="Delete All Zone"
            position="right"
          >
            <vs-button
              id="delete-all-button"
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              type="filled"
              @click="deleteSelectedAllShape()"
            ></vs-button>
          </vx-tooltip>
        </div>
      </vs-sidebar>
    </div>
    <!-- สิ้นสุด เเถบ silde วาดเส้นด้านซ้าย -->
    <!-- เเถบ silde รายการเรือในโครงการ excise tankers ด้านซ้าย -->
    <div id="excise-tankers">
      <vs-sidebar
        v-model="active"
        :hidden-background="true"
        click-not-close
        default-index="2"
        color="primary"
      >
        <div slot="header" class="header-sidebar">
          <div
            class="customizer-header mt-2 flex items-center justify-between px-2"
          >
            <div>
              <h4>Excise tanker</h4>
            </div>
            <div class="flex justify-between flex-end">
              <div class="flex items-center px-2">
                <chevrons-right-icon
                  size="1.5x"
                  class="custom-class cursor-pointer"
                  @click="setCollapsed(true)"
                ></chevrons-right-icon>
              </div>
              <feather-icon
                icon="XIcon"
                class="cursor-pointer"
                @click.stop="active = false"
              ></feather-icon>
            </div>
          </div>
          <vs-input
            v-model="searchQuery"
            placeholder="Search:MMSI,Name"
            class="w-full input-rounded-full no-icon-border no-shadow"
            icon="icon-search"
            icon-pack="feather"
          />
        </div>
        <VuePerfectScrollbar class="scroll-area--listExcise pt-4">
          <table style="font-size: 12px; width: 100%" class="table">
            <tr v-for="(item, index) in filteredKB" :key="index" class="pb-5">
              <vs-divider />
              <td class="text-center px-1">
                <b>{{ index + 1 }}.</b>
              </td>
              <td class="text-center px-0">
                <feather-icon
                  icon="AnchorIcon"
                  svgClasses="w-4 h-4"
                  class="px-0"
                ></feather-icon>
              </td>
              <td class="px-1">
                <b>{{ item.mmsi }}</b>
                <br />
                <p class="excise-name">{{ item.name }}</p>
              </td>
              <td class="pb-3 pt-3 px-2">
                <a
                  v-if="item.latitude || item.longitude"
                  href="#"
                  @click="handleSelected(item)"
                >
                  <vs-chip color="primary">View</vs-chip>
                </a>
                <a v-else href="#">
                  <vs-chip color="danger" style="cursor: auto" disabled
                    >View</vs-chip
                  >
                </a>
              </td>
            </tr>
          </table>
          <br />
        </VuePerfectScrollbar>
      </vs-sidebar>
    </div>
    <!-- สิ้นสุด เเถบ silde รายการเรือในโครงการ excise tankers ด้านซ้าย -->
    <!-- แสดงแผนที่ -->
    <div id="warp_map" ref="warp_map">
      <VesselController
        v-if="showController && vesselHistoryData.length - 1 >= 1"
        :onChangeValue="onChangeValue"
        :max="vesselHistoryData.length - 1"
        warpstyle="margin: 5px auto;"
      />
      <div id="map" ref="map"></div>
      <vs-button
        v-if="isFullScreen"
        color="red"
        class="exitFullScreen"
        @click="exitFullScreen"
        >Exit Full Screen</vs-button
      >
    </div>

    <!-- สิ้นสุด แสดงแผนที่ -->
    <!-- แสดงตำแหน่ง lat lng degree on google map ด้านบนซ้าน -->
    <div class="divLatLng">
      {{ degreeLatLngN }}
      <br />
      {{ degreeLatLngE }}
      <br />
      ({{ nowLat }},{{ nowLng }})
    </div>
    <!-- สิ้นสุด แสดงตำแหน่ง lat lng degree on google map ด้านบนซ้าน -->
    <!-- แถบ เเสดงรายละเอียดของเรือเเต่ล่ะลำ ด้านล่างของหน้าจอ google map -->
    <div
      v-if="detailVesselStatus == true"
      class="flex flex-wrap divDetail"
      style="padding-top: 0"
    >
      <div class="w-full sm:w-full md:w-full lg:w-full xl:full">
        <div class="grid-col-border text-center ml-auto pl-0 pr-0">
          <p>
            Vessel Detail
            <b
              v-if="detailVesselStatus == true"
              class="cursor-pointer"
              style="color: red"
              @click="
                (detailVesselStatus = !detailVesselStatus), infoWindow.close()
              "
              >[ Close ]</b
            >
          </p>
        </div>
        <div class="grid-col">
          <vs-row class="bt-2" vs-w="12">
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>id :</b>
              {{ vesselData.id }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>MMSI :</b>
              {{ vesselData.mmsi }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>MID Name :</b>
              {{ vesselData.mid_name | subStrName }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>last update :</b>
              {{ vesselData.updated_at | sumdate }}
              {{ vesselData.updated_at | sumtime }}
            </vs-col>
          </vs-row>

          <vs-row class="mt-2" vs-w="12">
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>IMO Number :</b>
              {{ vesselData.imo_number }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Name :</b>
              {{ vesselData.name }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Name Ship Type :</b>
              {{ vesselData.ship_type_id }}
              {{ vesselData.ship_type_name | subStrShipType }}
            </vs-col>
            <vs-col
              v-if="userRole == 'ROLE_SYSADMIN' || userRole == 'ROLE_ADMIN'"
              vs-justify="right"
              vs-align="right"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Report Type :</b>
              {{ vesselData.report_type }}
            </vs-col>
            <vs-col
              v-else
              vs-justify="right"
              vs-align="right"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            ></vs-col>
          </vs-row>

          <vs-row class="mt-2" vs-w="12">
            <!-- <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Ship class :</b>
              {{ vesselData.ship_class }}
            </vs-col> -->
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Call sign :</b>
              {{ vesselData.call_sign }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Length :</b>
              {{ vesselData.length }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Beam :</b>
              {{ vesselData.beam }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>ID Position Report :</b>
              {{ vesselData.position_report_id }}
            </vs-col>
          </vs-row>

          <vs-row class="mt-2" vs-w="12">
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Speed Over Ground :</b>
              {{ vesselData.speed_over_ground }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Voyage Destitnation :</b>
              {{ vesselData.voyage_destination | subStrDistanation }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Voyage Draught :</b>
              {{ vesselData.voyage_draught }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Latitude :</b>
              {{ vesselData.latitude }}
            </vs-col>
          </vs-row>

          <vs-row class="mt-2" vs-w="12">
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Longitude:</b>
              {{ vesselData.longitude }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>Name Navigation Status :</b>
              {{ vesselData.navigation_status_id }}
              {{ vesselData.navigation_status_name | subStrNavigaStatus }}
            </vs-col>
            <vs-col
              vs-justify="left"
              vs-align="left"
              vs-lg="3"
              vs-sm="3"
              vs-xs="12"
            >
              <b>True Heading :</b>
              {{ vesselData.true_heading }}
            </vs-col>
          </vs-row>
          <br />
        </div>
      </div>
    </div>
    <!-- ส้นสุด แถบ เเสดงรายละเอียดของเรือเเต่ล่ะลำ ด้านล่างของหน้าจอ google map -->
  </div>
</template>

<script>
/*global google*/
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "axios";
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/gmap/gmaps";
import { mapState } from "vuex";
import { ChevronsRightIcon } from "vue-feather-icons";
import { SERVER_SYNC_INTERVAL, API_BASE_URL } from "@/constants";
import VesselController from "./../../layouts/components/VesselController/VesselController.vue";
import {
  API_VESSEL_GROUPS,
  API_GET_ADMIN_VESSELS,
  API_GET_VESSELS,
  API_GET_BASE_STATIONS,
} from "@/constants/api";
import { dateFormat, mobileDevice } from "@/utils";
import VesselHistory from "../../layouts/components/vesselCustomizer/VesselHistory.vue";
import VesselList from "../../layouts/components/vesselCustomizer/VesselList.vue";
import BaseStation from "../../layouts/components/vesselCustomizer/BaseStation.vue";
import _ from "lodash";

export default {
  name: "RealTimeMonitoring",
  components: {
    VuePerfectScrollbar,
    VesselList,
    VesselHistory,
    VesselController,
    ChevronsRightIcon,
    BaseStation,
  },
  filters: {
    sumdate: (string) => {
      if (string != null) {
        let year = string.substring(0, 4);
        let sumYear = parseInt(year) + 543;
        let mount = string.substring(5, 7);
        let day = string.substring(8, 10);
        let date = day + "/" + mount + "/" + sumYear;

        return date;
      } else {
        return string;
      }
    },
    sumtime: (string) => {
      if (string != null) {
        return string.substring(11, 19);
      } else {
        return string;
      }
    },
    subStrName: (string) => {
      if (string != null) {
        return string.substring(0, 25) + "...";
      } else {
        return string;
      }
    },
    subStrShipType: (string) => {
      if (string != null) {
        return string.substring(0, 15) + "...";
      } else {
        return string;
      }
    },
    subStrNavigaStatus: (string) => {
      if (string != null) {
        return string.substring(0, 10) + "...";
      } else {
        return string;
      }
    },
    subStrDistanation: (string) => {
      if (string != null) {
        return string.substring(0, 10);
      } else {
        return string;
      }
    },
  },
  data() {
    return {
      isMobileDevice: mobileDevice(),
      all: require("../../milesSea/all.json"),
      port: require("../../milesSea/port.json"),
      statusTimeOut: true,
      statusFilterOrExcise: true,
      searchQueryBaseStation: "",
      activeBaseStation: false,
      activeDraw: false,
      notExpand: false,
      reduce: true,
      google: null,
      searchTanker: "",
      exciseList: [],
      activeConfirm: false,
      serverSyncTimer: null,
      firstLoaded: false,
      chkln: false,
      dataLatLngVessel: null,
      markersHashMap: null,
      myCoordinates: [],
      vesselHashMap: null,
      active: false,
      nowLat: null,
      nowLng: null,
      map: null,
      detailVesselStatus: false,
      geocoder: null,
      infoWindow: null,
      markerClusterer: null,
      markerClustererBaseStation: null,
      dataInPolygon: null,
      markers: [],
      markersBasestation: [],
      markersTextStation: [],
      rightShoulderFront: null,
      degreeLatLng: null,
      degreeLatLngE: null,
      degreeLatLngN: null,
      landBoundary: {},
      vesselData: {},
      vesselThm: null,
      vesselHistoryData: [],
      terrirorialEast: {},
      countLat: "16.452342",
      countLng: "102.831972",
      terrirorialWest: {},
      markerClustere: null,
      dataBaseStation: [],
      // Draw manager
      drawingManager: null,
      selectedShape: null,
      selectedAllShape: [],
      colors: [
        "#fc0000",
        "#0bff00",
        "#0b00ff",
        "#ffff00",
        "#ff6600",
        "#006600",
        "#cc0099",
        "#cc9900",
        "#66ff99",
        "#990033",
        "#9933ff",
        "#996600",
      ],
      selectedColor: null,
      colorButtons: {},
      searchQuery: "",
      accessEmail: "",
      accessToken: "",
      listBaseStationnew: [],
      userRole: "",
      statetusRemoveBase: true,
      statusZoom: false,
      statusTxtZoom: false,
      statusColorPanel: 1,
      statusColorDrawing: true,
      excisemmsiList: "",
      excisemmsiListDetail: [],
      statusVesselVallback: false,
      polyline: undefined,
      dotMarket: [],
      //
      warpMap: null,
      showController: false,
      isFullScreen: false,
      //
      collapsed: false,
      //
      isActiveVesselList: false,
      isActivevesselHistory: false,
      selectedDrawing: "",
      circleMarker: [],
    };
  },
  computed: mapState({
    dataVessel: (state) => state.dataVessel,
    filterVessel: (state) => state.filterVessel,
    selectVessel: (state) => state.selectVessel,
    selectBaseStation: (state) => state.selectBaseStation,
    filteredKB() {
      return this.exciseList.filter((item) => {
        const isNumber = !isNaN(this.searchQuery);
        if (typeof item.mmsi == "string" && isNumber) {
          return item.mmsi
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase());
        }
        console.log("sadjsakldjls");
        if (typeof item.name == "string" && !isNumber) {
          return item.name
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase());
        }
        return false;
      });
    },
    filteredKBBase() {
      return this.newDataBaseStation.filter((item) => {
        const isNumber = !isNaN(this.searchQueryBaseStation);
        if (typeof item.mmsi == "string" && isNumber) {
          return item.mmsi
            .toLowerCase()
            .includes(this.searchQueryBaseStation.toLowerCase());
        }
        if (typeof item.name == "string" && !isNumber) {
          return item.name
            .toLowerCase()
            .includes(this.searchQueryBaseStation.toLowerCase());
        }
        return false;
      });
    },
    newDataBaseStation: (state) => state.realtimeMonitoring.baseStationData,
  }),
  watch: {
    statusVesselVallback(val) {
      this.callExsiceTanker();
      if (val) {
        setTimeout(() => {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        }, 2000);
      }
    },
    activeBaseStation(val) {
      if (val) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
          this.markers[i] = undefined;
        }
        this.markerClusterer.clearMarkers();
        this.markers = [];
      } else {
        this.showMarkers();
      }
    },
    activeDraw() {
      if (this.activeDraw == false) {
        this.statusColorPanel = 1;
      } else {
        this.statusColorPanel = 2;
      }
    },
    filteredKB() {
      function compare(a, b) {
        const bandA = typeof a.name == "string" ? a.name.toUpperCase() : "";
        const bandB = typeof b.name == "string" ? b.name.toUpperCase() : "";

        let comparison = 0;
        if (bandA > bandB) {
          comparison = 1;
        } else if (bandA < bandB) {
          comparison = -1;
        }
        return comparison;
      }
      this.filteredKB.sort(compare);
    },
    filterVessel() {
      this.statusTimeOut = false;
      this.active = false;
      this.statusFilterOrExcise = false;
      if (this.markers) {
        for (let i in this.markers) {
          this.markers[i].setMap(null);
        }
      }
      this.markers = [];
      this.initMap();
    },
    active(val) {
      if (val) {
        this.statusTimeOut == false;
        this.statusFilterOrExcise = true;
        this.setCollapsed(!val);
      } else {
        this.statusTimeOut == true;
        this.collapsed = false;
      }
      if (this.markers) {
        for (let i in this.markers) {
          this.markers[i].setMap(null);
        }
      }
      this.markers = [];
      this.initMap();
    },
    selectBaseStation(val) {
      var latLng = new google.maps.LatLng(val.latitude, val.longitude);
      this.map.setCenter(latLng);
      this.map.setZoom(13);
      this.showInfoWindow(val);
    },
    selectVessel(val) {
      var latLng = new google.maps.LatLng(val.latitude, val.longitude);
      this.map.setCenter(latLng);
      this.map.setZoom(13);
      this.showInfoWindow(val);
      this.vesselData = val;
      this.detailVesselStatus = true;
    },
    dataVessel(val) {
      if (this.firstLoaded == false) {
        this.initMap();
        this.firstLoaded = true;
      } else {
        val.forEach((it) => {
          let marker = this.markersHashMap.get(it.id);
          var vessels = this.vesselHashMap.get(it.id);
          if (marker) {
            if (
              it.latitude &&
              it.longitude &&
              (it.latitude != vessels.latitude ||
                it.longitude != vessels.longitude)
            ) {
              // update marker (no need to update whole key,value in markerHashmap, because of using marker.setPosition() to update marker object itself

              this.updateMarker(it, marker);
              // update dataunivers in hashmap
              //  let markerNew = this.createMarker(it);
              // this.markersHashMap.set(it.id, markerNew);
              this.vesselHashMap.set(it.id, it);
            }
          }
        });

        // setTimeout(() => {
        //   console.log("sync")
        //   if (this.statusTimeOut == true) {
        //     this.serverSync();
        //   } else if (this.statusTimeOut == false) {
        //     console.log("no sync");
        //   }
        // }, SERVER_SYNC_INTERVAL);
      }
    },
  },
  async mounted() {
    this.openLoadingContained();
    this.$vs.loading();
    this._keyListener = function (e) {
      if (e.key === "l" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault(); // present "Save Page" from getting triggered.
        this.copyLatLng();
      }
    };
    document.addEventListener("keydown", this._keyListener.bind(this));
    this.$store.dispatch("updateTitlePage", "Realtime mornitoring");
  },
  async created() {
    this.accessEmail = localStorage.getItem("accessEmail");

    this.accessToken = localStorage.getItem("accessToken");
    let role = localStorage.getItem("userRole");

    if (role == "ROLE_SYSADMIN") {
      this.userRole = "ROLE_SYSADMIN";
    } else if (role == "ROLE_ADMIN") {
      this.userRole = "ROLE_ADMIN";
    } else if (role == "ROLE_EDITOR") {
      this.userRole == "ROLE_EDITOR";
    } else if (role == "ROLE_VIEWER") {
      this.userRole = "ROLE_VIEWER";
    } else if (role == "ROLE_OBSERVE_EXCISE_TANKER"){
      this.userRole = "ROLE_OBSERVE_EXCISE_TANKER";
    }
    this.getdataExciseTanker();
    this.$vs.loading();
    this.serverSync();
  },
  methods: {
    setCollapsed(flag) {
      const elem = document.querySelector("#excise-tankers");
      const sidebar = elem.getElementsByClassName("vs-sidebar");
      if (flag) {
        sidebar[0].style.width = "0vw";
        sidebar[0].style.visibility = "hidden";
      } else {
        sidebar[0].style.width = "300px";
        sidebar[0].style.visibility = "visible";
      }
      this.collapsed = flag;
    },
    async getdataExciseTanker() {
      const url = API_VESSEL_GROUPS();
      await axios
        .get(url, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken,
          },
        })
        .then((response) => {
          this.excisemmsiList = response.data.mmsi_list;
        })
        .catch((error) => {
          console.log("Error call apis :", error);
        });
      await this.convertmmsiList();
    },
    openLoadingContained() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45,
      });
    },
    async convertmmsiList() {
      var ar = this.excisemmsiList.split(",");
      let x = 0;
      for (let i = 0; i < ar.length; i++) {
        await this.fineExciseTankerList(ar[i]);
        if (x == ar.length - 1) {
          this.statusVesselVallback = true;
        }
        x++;
      }
    },
    async fineExciseTankerList(mmsi) {
      const url = API_GET_ADMIN_VESSELS();
      await axios
        .get(url, {
          params: {
            "q[mmsi_or_imei_or_imo_number_or_imn_number_or_radio_channel_or_name_or_ship_class_or_vendor_id_or_call_sign_or_reg_number_or_color_or_description_or_other_com_ch_or_owner_name_or_owner_address_or_owner_phone_or_master_name_or_master_address_or_master_phone_cont]":
              mmsi,
            "q[is_visible_true]": 1,
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken,
          },
        })
        .then((response) => {
          if (response.data[0] != undefined) {
            this.excisemmsiListDetail.push(response.data[0]);
          }
        })
        .catch((error) => {
          console.log("vessel list API error:", error);
        });
    },
    async callExsiceTanker() {
      const url = API_GET_VESSELS();
      await axios
        .get(url, {
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken,
          },
        })
        .then((response) => {
          this.exciseList = [];
          let dataall = [];
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].icon_type == "EXCISE") {
              dataall.push(response.data[i]);
            }
          }
          for (let l = 0; l < this.excisemmsiListDetail.length; l++) {
            for (let j = 0; j < dataall.length; j++) {
              if (
                dataall[j].mmsi == this.excisemmsiListDetail[l].mmsi &&
                dataall[j].mmsi != null
              ) {
                this.exciseList.push(dataall[j]);
                break;
              }
              if (j == dataall.length - 1) {
                this.exciseList.push(this.excisemmsiListDetail[l]);
              }
            }
          }
        })
        .catch((error) => {
          console.log("Excise Tanker API error:", error);
        });
    },
    copyLatLng() {
      const thisIns = this;
      var latlng = `${this.nowLat},${this.nowLng}`;
      this.$copyText(latlng).then(
        function () {
          thisIns.$vs.notify({
            title: "Success",
            text: `${latlng} copied successfully`,
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        },
        function () {
          thisIns.$vs.notify({
            title: "Failed",
            text: "Error in copying Lat lng ",
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
        }
      );
    },
    handleSelected(item) {
      this.$store.dispatch("updateSelectVessel", item);
    },
    handleSelectedBaseStation(basestation) {
      for (let i = 0; i < this.listBaseStationnew.length; i++) {
        if (this.listBaseStationnew[i].mmsi == basestation.mmsi) {
          var latLng = new google.maps.LatLng(
            this.listBaseStationnew[i].latitude,
            this.listBaseStationnew[i].longitude
          );
          this.map.setCenter(latLng);
          this.map.setZoom(13);
          this.showInfoWindow(this.listBaseStationnew[i]);
        }
      }
    },
    async showInfoWindow(vessel) {
      var mmis = vessel.mmsi;
      // var name = vessel.mid_name;
      // var url = "";
      var mid = vessel.name;
      var lat = vessel.latitude;
      var lng = vessel.longitude;
      var latlng = await new google.maps.LatLng(lat, lng);

      var infoHtml =
        '<div class="info"><p> MMIS : ' +
        mmis +
        " <br> Name: " +
        mid +
        " <br> latitude : " +
        lat +
        " <br> longitude : " +
        lng +
        "</p>" +
        '<div class="info-body">' +
        "</a></div></div>";

      this.infoWindow.setContent(infoHtml);
      this.infoWindow.setPosition(latlng);
      this.infoWindow.open(this.map);
    },
    async showInfoWindowDrawing(draw, flag) {
      var lat1 = draw[0].lat;
      var lon1 = draw[0].lng;
      var lat2 = draw[draw.length - 1].lat;
      var lon2 = draw[draw.length - 1].lng;

      var R = 6371; // km (change this constant to get miles)
      var dLat = ((lat2 - lat1) * Math.PI) / 180;
      var dLon = ((lon2 - lon1) * Math.PI) / 180;
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
          Math.cos((lat2 * Math.PI) / 180) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      var total;
      if (d > 1) total = d.toFixed(2) + " km";
      else if (d <= 1) total = (d * 1000).toFixed(2) + " m";

      var totalmile = (d * 0.62137).toFixed(2) + " nmi";

      var latlng = await new google.maps.LatLng(lat2, lon2);

      if (flag) {
        const infoWindow = new google.maps.InfoWindow();
        const infoHtml = `<div><p>${total} (${totalmile})</p></div>`;
        infoWindow.setContent(infoHtml);
        infoWindow.setPosition(latlng);
        infoWindow.open(this.map);
        this.infoWindow.close();
        return;
      }
      const infoHtml = `<div ><p>${total} (${totalmile})</p></div>`;
      this.infoWindow.setContent(infoHtml);
      this.infoWindow.setPosition(latlng);
      this.infoWindow.open(this.map);
    },
    async showInfoWindowCircle(circle) {
      var latlng = await new google.maps.LatLng(
        circle.getCenter().lat(),
        circle.getCenter().lng()
      );
      var total =
        (Math.PI * (circle.radius + circle.radius)).toFixed(2) +
        "km<sup>2</sup>";
      var totalmile =
        (Math.PI * (circle.radius + circle.radius) * 0.62137).toFixed(2) +
        "nmi<sup>2</sup>";
      var radius = (circle.radius / 1000).toFixed(2) + " km";
      var radiusMile = ((circle.radius / 1000) * 0.62137).toFixed(2) + " nmi";

      var infoHtml = `<div ><p>Radius : ${radius} (${radiusMile})</p><br><p>Area : ${total} (${totalmile})</p></div>`;

      this.infoWindow.setContent(infoHtml);
      this.infoWindow.setPosition(latlng);
      this.infoWindow.open(this.map);
    },
    async showInfoWindowPolygon(polygon, area, length) {
      var lat = polygon[0].lat;
      var lng = polygon[0].lng;
      var latlng = await new google.maps.LatLng(lat, lng);

      var totalArea = area.toFixed(2) + " km<sup>2</sup> ";
      var totalAreamile = (area * 0.62137).toFixed(2) + " nmi<sup>2</sup> ";
      var totalLength = length.toFixed(2) + " km ";
      var totalLengthmile = (length * 0.62137).toFixed(2) + " nmi ";

      var infoHtml = `<div><p>Length : ${totalLength} (${totalLengthmile})</p><br><p>Area : ${totalArea} (${totalAreamile})</p></div> `;

      this.infoWindow.setContent(infoHtml);
      this.infoWindow.setPosition(latlng);
      this.infoWindow.open(this.map);
    },
    async showInfoWindowPolyline(polyline, length) {
      var polylineLength = polyline.length;
      var lat = polyline[polylineLength - 1].lat;
      var lng = polyline[polylineLength - 1].lng;
      var latlng = await new google.maps.LatLng(lat, lng);

      var total = length.toFixed(2) + " km ";
      var totalmile = (length * 0.62137).toFixed(2) + " nmi ";

      var infoHtml = `<div><p>${total} (${totalmile})</p></div> `;

      this.infoWindow.setContent(infoHtml);
      this.infoWindow.setPosition(latlng);
      this.infoWindow.open(this.map);
    },
    async showInfoWindowRectangel(rectangle) {
      var bounds = rectangle.getBounds();
      var center = bounds.getCenter();
      var start = bounds.getNorthEast();
      var end = bounds.getSouthWest();
      var lat1 = start.lat();
      var lng1 = start.lng();
      var lat2 = end.lat();
      var lng2 = end.lng();

      var R = 6371; // km (change this constant to get miles)
      var dLat = ((lat2 - lat1) * Math.PI) / 180;
      var dLon = ((lng2 - lng1) * Math.PI) / 180;
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
          Math.cos((lat2 * Math.PI) / 180) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      var total;

      if (d > 1) total = d.toFixed(2);
      else if (d <= 1) total = (d * 1000).toFixed(2);

      var totalmile = (d * 0.62137).toFixed(2);

      var latlng = await new google.maps.LatLng(center.lat(), center.lng());

      var area = ((total * total) / 2).toFixed(2) + " km<sup>2</sup> ";
      var areamile =
        ((totalmile * totalmile) / 2).toFixed(2) + " nmi<sup>2</sup> ";

      const infoHtml = `<div ><p>${area} (${areamile})</p></div>`;
      this.infoWindow.setContent(infoHtml);
      this.infoWindow.setPosition(latlng);
      this.infoWindow.open(this.map);
    },
    async serverSync() {
      console.log("serverSync");
      const url = API_GET_VESSELS();
      await axios
      .get(url, {
        params: {
          "q[is_visible_true]": 1,
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken,
        },
      })
      .then((response) => {
        if (this.userRole == "ROLE_OBSERVE_EXCISE_TANKER") {
          const excise = _.filter(response.data, (o)=>{ return o.icon_type == "EXCISE"; });
          this.$store.dispatch("updateVessel", excise);
        } else {
          this.$store.dispatch("updateVessel", response.data);
        }

        setTimeout(() => {
          if (this.statusTimeOut) {
            this.serverSync();
          }
        }, SERVER_SYNC_INTERVAL);
      })
      .catch(() => {
        // console.log("API error:", error);
        setTimeout(() => {
          if (this.statusTimeOut == true) {
            this.serverSync();
          } else if (this.statusTimeOut == false) {
            console.log("no sync");
          }
        }, SERVER_SYNC_INTERVAL);
      });
    
     },
    async initMap() {
      // console.log("init map");
      try {
        this.google = await gmapsInit();
        this.geocoder = new google.maps.Geocoder();
        const latlng = new google.maps.LatLng(10.18383, 100.60639);
        const options = {
          zoom: 7,
          center: latlng,
          streetViewControl: false,
          mapTypeControl: false,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          fullscreenControl: true,
          gestureHandling: "greedy",
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER,
          },
        };

        this.map = new google.maps.Map(this.$el.querySelector("#map"), options);
        this.warpMap = this.$el.querySelector("#warp_map");
        this.infoWindow = new google.maps.InfoWindow();
        this.showMarkers();
        google.maps.event.trigger(this.map, "resize");
        this.map.data.setStyle((feature) => {
          var color = feature.getProperty("color");
          if (color == "red") {
            color = "red";
          } else if (color == "green") {
            color = "#10FD1E";
          } else if (color == "blue") {
            color = "#00BDFF";
          }
          return {
            clickable: false,
            fillColor: color,
            strokeWeight: 0,
          };
        });
        this.map.data.addGeoJson(this.all);
        google.maps.event.addListener(this.map, "mousemove", (event) => {
          var lat = event.latLng.lat();
          var lng = event.latLng.lng();
          this.nowLat = lat.toFixed(5);
          this.nowLng = lng.toFixed(5);

          var latitude = this.toDegreesMinutesAndSeconds(lat);
          var latitudeCardinal = lat >= 0 ? "N" : "S";
          var longitude = this.toDegreesMinutesAndSeconds(lng);
          var longitudeCardinal = lng >= 0 ? "E" : "W";
          this.degreeLatLngN = latitude + "'' " + latitudeCardinal;
          this.degreeLatLngE = longitude + "'' " + longitudeCardinal;

          this.degreeLatLng =
            latitude +
            "'' " +
            latitudeCardinal +
            " | " +
            longitude +
            "'' " +
            longitudeCardinal;
        });
        this.showMarkersBaseStation();
        this.statusZoom = true;
        this.initDrawManager();
        if (this.statusColorDrawing) {
          this.buildColorPalette();
          this.statusColorDrawing = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    toDegreesMinutesAndSeconds(coordinate) {
      var absolute = Math.abs(coordinate);
      var degrees = Math.floor(absolute);
      var minutesNotTruncated = (absolute - degrees) * 60;
      var minutes = Math.floor(minutesNotTruncated);
      var seconds = Math.floor((minutesNotTruncated - minutes) * 60);

      return degrees + "°" + minutes + "'" + seconds;
    },
    createMarker(dataVessel) {
      const latLng = new google.maps.LatLng(
        dataVessel.latitude,
        dataVessel.longitude
      );
      const imageUrl = this.getVesselImg(dataVessel);
      const markerImage = this.createMarkerIcon(imageUrl);

      const marker = new google.maps.Marker({
        position: latLng,
        icon: markerImage,
        map: this.map,
      });
      var fn1 = this.markerClickFunction1(dataVessel, latLng);
      var fn2 = this.markerClickFunction2(dataVessel, latLng);
      var fn3 = this.markerClickFunction3(dataVessel, latLng);
      google.maps.event.addListener(marker, "mouseover", fn1);
      google.maps.event.addListener(marker, "click", fn2);
      google.maps.event.addListener(marker, "mouseout", fn3);
      return marker;
    },
    markerOnMouseMoveBaseStatus(baseStatus, latlng) {
      return (e) => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }

        const mmis = baseStatus.mmsi;
        const mid = baseStatus.name;
        const lat = baseStatus.latitude;
        const lng = baseStatus.longitude;
        const country = _.get(baseStatus, "country.name", "");

        var infoHtml =
          '<div class="info"><p> MMIS : ' +
          mmis +
          " <br> name : " +
          mid +
          " <br> latitude : " +
          lat +
          " <br> longitude : " +
          lng +
          " <br> Country : " +
          country +
          "</p>" +
          '<div class="info-body">' +
          "</div></div>";

        this.infoWindow.setContent(infoHtml);
        this.infoWindow.setPosition(latlng);
        this.infoWindow.open(this.map);
      };
    },
    createMarkerIcon(imageUrl, imgSize) {
      const size = imgSize || 30;
      var markerImage = new google.maps.MarkerImage(
        imageUrl,
        new google.maps.Size(size, size),
        new google.maps.Point(0, 0),
        new google.maps.Point(size / 2, size / 2),
        new google.maps.Size(size, size)
      );
      return markerImage;
    },
    updateMarker(vessel, marker) {
      let position = new google.maps.LatLng(vessel.latitude, vessel.longitude);
      marker.setPosition(position);

      let imageUrl = this.getVesselImg(vessel);
      let markerImage = this.createMarkerIcon(imageUrl);
      marker.setIcon(markerImage);

      var fn1 = this.markerClickFunction1(vessel, position);
      var fn2 = this.markerClickFunction2(vessel, position);
      var fn3 = this.markerClickFunction3(vessel, position);
      google.maps.event.addListener(marker, "mouseover", fn1);
      google.maps.event.addListener(marker, "click", fn2);
      google.maps.event.addListener(marker, "mouseout", fn3);
    },
    showMarkersTextStation() {
      const dataPort = this.port.data;
      const markerImage = new google.maps.MarkerImage(
        "/empty.png",
        new google.maps.Size(30, 30),
        new google.maps.Point(0, 0),
        new google.maps.Point(15, 15),
        new google.maps.Size(30, 30)
      );
      for (let i = 0; i < dataPort.length; i++) {
        const latLng = new google.maps.LatLng(dataPort[i].lat, dataPort[i].lng);
        const marker = new google.maps.Marker({
          position: latLng,
          icon: markerImage,
          map: this.map,
          zIndex: 99999,
          label: {
            color: "#FF0000",
            text: dataPort[i].title,
            fontSize: "18px",
          },
        });
        this.markersTextStation.push(marker);
      }
    },
    showMarkersBaseStation() {
      const url = API_GET_BASE_STATIONS();
      axios
        .get(url, {
          params: {
            "q[longitude_not_null]": 1,
            "q[latitude_not_null]": 1,
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken,
          },
        })
        .then((response) => {
          this.listBaseStationnew = response.data;
          this.markersBasestation = [];
          var markerImage = new google.maps.MarkerImage(
            "/vesselIcon/base_stations/online.png",
            new google.maps.Size(30, 30),
            new google.maps.Point(0, 0),
            new google.maps.Point(15, 15),
            new google.maps.Size(30, 30)
          );

          for (var i = 0; i < response.data.length; i++) {
            var latLng = new google.maps.LatLng(
              response.data[i].latitude,
              response.data[i].longitude
            );
            this.setMarker = new google.maps.Marker({
              position: latLng,
              icon: markerImage,
              map: this.map,
            });

            this.markersBasestation.push(this.setMarker);
            var fn1 = this.markerOnMouseMoveBaseStatus(
              response.data[i],
              latLng
            );
            google.maps.event.addListener(this.setMarker, "mouseover", fn1);
          }
        })
        .catch((error) => {
          console.log("Base station Error :", error);
        });
    },
    showMarkers() {
      let markerData;
      this.markers = [];
      this.markersHashMap = new Map();
      this.vesselHashMap = new Map();
      if (this.statusTimeOut == true && this.active == false) {
        markerData = this.dataVessel;
      } else if (this.statusFilterOrExcise == true && this.active == true) {
        markerData = this.exciseList;
      } else if (this.statusFilterOrExcise == false && this.active == false) {
        markerData = this.filterVessel;
      }
      for (let i = 0; i < markerData.length; i++) {
        const marker = this.createMarker(markerData[i]);
        this.markersHashMap.set(markerData[i].id, marker);
        this.vesselHashMap.set(markerData[i].id, marker);
        this.markers.push(marker);
      }
      window.setTimeout(() => this.renderMakerCusterVessel(this.markers), 100);
      google.maps.event.addListener(this.map, "zoom_changed", () => {
        const zoomLevel = this.map.getZoom();
        if (zoomLevel <= 6) {
          this.statusZoom = false;
          for (let i in this.markersBasestation) {
            this.markersBasestation[i].setMap(null);
          }
          this.markersBasestation = [];
          // show text
          // this.showMarkersTextStation();
        } else if (zoomLevel > 6) {
          if (this.statusZoom == false) {
            this.showMarkersBaseStation();
            this.statusZoom = true;
          }
        }

        if (zoomLevel >= 10) {
          if (this.statusTxtZoom == false) {
            this.statusTxtZoom = true;
            this.showMarkersTextStation();
          }
        } else if (zoomLevel < 10) {
          this.statusTxtZoom = false;
          for (let i in this.markersTextStation) {
            this.markersTextStation[i].setMap(null);
          }
          this.markersTextStation = [];
        }
      });
    },
    renderMakerCusterVessel(markers) {
      const options = {
        maxZoom: 6,
        styles: [
          {
            textColor: "black",
            url: "http:///developers.google.com/maps/documentation/javascript/examples/markerclusterer/m2.png",
            width: 57,
            height: 57,
          },
        ],
      };
      this.markerClusterer = new MarkerClusterer(this.map, markers, options);
    },
    renderMakerCusterBaseStation(markers) {
      const options = {
        maxZoom: 6,
        styles: [
          {
            textColor: "black",
            url: "http:///developers.google.com/maps/documentation/javascript/examples/markerclusterer/m2.png",
            width: 57,
            height: 57,
          },
        ],
      };
      this.markerClustererBaseStation = new MarkerClusterer(
        this.map,
        markers,
        options
      );
    },
    markerClickFunction1(vessel, latlng) {
      return (e) => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        const mmis = vessel.mmsi;
        const mid = vessel.name;
        const lat = vessel.latitude;
        const lng = vessel.longitude;
        const speed = vessel.speed_over_ground;
        const hdg_cog = vessel.true_heading || vessel.hdg_cog;
        let record_time = undefined;
        if (vessel.record_time) {
          record_time = dateFormat(vessel.record_time);
        }

        let infoHtml = `<div class="info">`;
        infoHtml += mmis ? `<p>MMIS: ${mmis}</p>` : "";
        infoHtml += mmis ? `<p>name: ${mid}</p>` : "";
        infoHtml += `<p>latitude: ${lat}</p>`;
        infoHtml += `<p>longitude: ${lng}</p>`;
        infoHtml += mmis ? `<p>true heading: ${hdg_cog}</p>` : "";
        infoHtml += mmis ? `<p>speed over ground: ${speed}</p>` : "";
        infoHtml += record_time ? `<p>record time: ${record_time}</p>` : "";
        infoHtml += `</div>`;

        this.infoWindow.setContent(infoHtml);
        this.infoWindow.setPosition(latlng);
        this.infoWindow.open(this.map);
      };
    },
    markerClickFunction2(vessel, latLng) {
      return (e) => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        this.vesselData = vessel;
        this.detailVesselStatus = true;
      };
    },
    markerClickFunction3(vessel, latLng) {
      return (e) => {
        e.cancelBubble = true;
        e.returnValue = false;
        if (e.stopPropagation) {
          e.stopPropagation();
          e.preventDefault();
        }
        this.infoWindow.close();
      };
    },
    getDirection(direction) {
      const n = direction % 10 ? 0 : 1;
      const tpye = Math.ceil(direction / 10) + n;
      return tpye > 36 ? 10 : tpye;
    },
    getVesselImg(vessel) {
      const direction = vessel.hdg_cog || 360;
      let iconType = vessel.icon_type;
      const shipType = vessel.navigation_status_code == "0" ? "b" : "";
      let imgShip = "other";
      if (iconType == "tanker") {
        imgShip = "tanker";
      } else if (iconType == "other") {
        imgShip = "other";
      } else if (iconType == "passenger") {
        imgShip = "passenger";
      } else if (iconType == "cargo") {
        imgShip = "cargo";
      } else if (iconType == "fishing") {
        imgShip = "fishing";
      } else if (iconType == "EXCISE") {
        imgShip = "excise";
      }
      const imageUrl = `/vesselIcon/${imgShip}/${shipType}${this.getDirection(
        direction
      )}.png`;
      return imageUrl;
    },
    onCloseBaseStation() {
      this.activeBaseStation = false;
    },
    onActiveDrawer() {
      this.activeDraw = !this.activeDraw;

      this.notExpand = true;
      this.activeBaseStation = false;
      this.isActiveVesselList = false;
      this.isActivevesselHistory = false;
      this.detailVesselStatus = false;
      this.active = false;
    },
    onActiveExciseTanker() {
      this.active = !this.active;

      this.detailVesselStatus = false;
      this.activeDraw = false;
      this.notExpand = true;
      this.activeBaseStation = false;
      this.isActiveVesselList = false;
      this.isActivevesselHistory = false;
    },
    onActiveBaseStation() {
      this.activeBaseStation = true;

      this.activeDraw = false;
      this.notExpand = true;
      this.detailVesselStatus = false;
      this.active = false;
      this.isActiveVesselList = false;
      this.isActivevesselHistory = false;
    },
    onActiveVesselList() {
      this.isActiveVesselList = true;

      this.activeBaseStation = false;
      this.activeDraw = false;
      this.active = false;
      this.isActivevesselHistory = false;
    },
    onActiveVesselHistory() {
      this.isActivevesselHistory = true;

      this.activeBaseStation = false;
      this.activeDraw = false;
      this.active = false;
      this.isActiveVesselList = false;
    },
    cancelAutoUpdate: function () {
      clearInterval(this.serverSyncTimer);
    },
    beforeDestroy() {
      clearInterval(this.serverSyncTimer);
    },
    // Draw manager
    clearSelection() {
      if (this.selectedShape) {
        this.selectedShape.setEditable(false);
        this.selectedShape = null;
      }
    },
    setSelection(shape) {
      this.clearSelection();
      this.selectedShape = shape;
      this.selectedAllShape.push(shape);
      shape.setEditable(true);
      this.selectColor(shape.get("fillColor") || shape.get("strokeColor"));
    },
    deleteSelectedShape() {
      if (this.selectedShape) {
        this.selectedShape.setMap(null);
      }
    },
    deleteSelectedAllShape() {
      for (var i = 0; i < this.selectedAllShape.length; ++i) {
        this.selectedAllShape[i].setMap(null);
      }
    },
    selectColor(color) {
      this.selectedColor = color;
      for (var i = 0; i < this.colors.length; ++i) {
        var currColor = this.colors[i];
        this.colorButtons[currColor].style.border =
          currColor == color ? "2px solid #789" : "2px solid #fff";
      }

      // Retrieves the current options from the drawing manager and replaces the
      // stroke or fill color as appropriate.
      var polylineOptions = this.drawingManager.get("polylineOptions");
      polylineOptions.strokeColor = color;
      this.drawingManager.set("polylineOptions", polylineOptions);

      var rectangleOptions = this.drawingManager.get("rectangleOptions");
      rectangleOptions.fillColor = color;
      this.drawingManager.set("rectangleOptions", rectangleOptions);

      var circleOptions = this.drawingManager.get("circleOptions");
      circleOptions.fillColor = color;
      this.drawingManager.set("circleOptions", circleOptions);

      var polygonOptions = this.drawingManager.get("polygonOptions");
      polygonOptions.fillColor = color;
      this.drawingManager.set("polygonOptions", polygonOptions);
    },
    setSelectedShapeColor(color) {
      if (this.selectedShape) {
        if (
          this.selectedShape.type == google.maps.drawing.OverlayType.POLYLINE
        ) {
          this.selectedShape.set("strokeColor", color);
        } else {
          this.selectedShape.set("fillColor", color);
        }
      }
    },
    makeColorButton(color) {
      var button = document.createElement("span");
      button.className = "color-button";
      button.style.backgroundColor = color;
      google.maps.event.addDomListener(button, "click", () => {
        this.selectColor(color);
        this.setSelectedShapeColor(color);
      });

      return button;
    },
    buildColorPalette() {
      var colorPalette = document.getElementById("color-palette");
      for (var i = 0; i < this.colors.length; ++i) {
        var currColor = this.colors[i];
        var colorButton = this.makeColorButton(currColor);
        colorPalette.appendChild(colorButton);
        this.colorButtons[currColor] = colorButton;
      }
      this.selectColor(this.colors[0]);
    },
    draw(type) {
      var polyOptions = {
        strokeWeight: 0,
        fillOpacity: 0.45,
        editable: true,
      };
      this.selectedDrawing = type;
      if (this.drawingManager) {
        this.drawingManager.setDrawingMode(null);
      }
      // markers, lines, and shapes.
      switch (type) {
        case "Polygon":
          this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: false,
            polygonOptions: polyOptions,
            markerOptions: {
              draggable: true,
            },
            polylineOptions: {
              editable: true,
            },
            rectangleOptions: polyOptions,
            circleOptions: polyOptions,
            map: this.map,
          });
          break;
        case "Circle":
          this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.CIRCLE,
            drawingControl: false,
            polygonOptions: polyOptions,
            markerOptions: {
              draggable: true,
            },
            polylineOptions: {
              editable: true,
            },
            rectangleOptions: polyOptions,
            circleOptions: polyOptions,
            map: this.map,
          });
          break;
        case "PolyLine":
          this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYLINE,
            drawingControl: false,
            polygonOptions: polyOptions,
            markerOptions: {
              draggable: true,
            },
            polylineOptions: {
              editable: true,
            },
            rectangleOptions: polyOptions,
            circleOptions: polyOptions,
            map: this.map,
          });
          break;
        case "Rectangle":
          this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.RECTANGLE,
            drawingControl: false,
            polygonOptions: polyOptions,
            markerOptions: {
              draggable: true,
            },
            polylineOptions: {
              editable: true,
            },
            rectangleOptions: polyOptions,
            circleOptions: polyOptions,
            map: this.map,
          });
          break;
      }

      function trunc(x) {
        return Math.round(x * 1000) / 1000;
      }

      const getLatLngByOffset = (map, offsetX, offsetY) => {
        var currentBounds = this.map.getBounds();
        var topLeftLatLng = new google.maps.LatLng(
          currentBounds.getNorthEast().lat(),
          currentBounds.getSouthWest().lng()
        );
        var point = this.map.getProjection().fromLatLngToPoint(topLeftLatLng);
        point.x += offsetX / (1 << this.map.getZoom());
        point.y += offsetY / (1 << this.map.getZoom());
        return this.map.getProjection().fromPointToLatLng(point);
      };

      var arrLatLngMouseMove = [];
      const getLocationText = (location) => {
        var lat = trunc(location.lat());
        var lng = trunc(location.lng());
        arrLatLngMouseMove.push({ lat, lng });
        this.showInfoWindowDrawing(arrLatLngMouseMove);
        $("#map").click(function () {
          arrLatLngMouseMove = [];
        });
      };

      $("#map").click(function (e) {
        // console.log("click start", type,e);
        $("#map").mousemove(function (evt) {
          const headerHeight = this.isFullScreen ? 0 : 80;
          const sideBarWidth = window.innerWidth < 1200 ? 0 : 80;
          var posx = evt.pageX - this.offsetLeft - sideBarWidth;
          var posy = evt.pageY - this.offsetTop - headerHeight;
          getLocationText(getLatLngByOffset(this.map, posx, posy));
        });
      });

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        (e) => {
          // Switch back to non-drawing mode after drawing a shape.
          this.drawingManager.setDrawingMode(null);
          if (e.type != google.maps.drawing.OverlayType.MARKER) {
            var newShape = e.overlay;
            newShape.type = e.type;
            google.maps.event.addListener(newShape, "click", (e) => {
              this.setSelection(newShape);
            });
            this.setSelection(newShape);
          }
          this.activeDraw = true;
          this.selectedDrawing = "";
          $("#map").click(function () {
            $("#map").off("mousemove");
          });
        }
      );

      switch (type) {
        case "Polygon":
          this.drawPolygon();
          break;
        case "Circle":
          this.drawCircle();
          break;
        case "PolyLine":
          this.drawPolyLine();
          break;
        case "Rectangle":
          this.drawRectangle();
          break;
      }

      // Clear the current selection when the drawing mode is changed, or when the
      // map is clicked.
      google.maps.event.addListener(
        this.drawingManager,
        "drawingmode_changed",
        this.clearSelection
      );
      google.maps.event.addListener(this.map, "click", this.clearSelection);
    },
    drawPolygon() {
      google.maps.event.addListener(
        this.drawingManager,
        "polygoncomplete",
        (polygon) => {
          const vm = this;
          var arr = [];
          function getPath() {
            var path = polygon.getPath();
            var area =
              google.maps.geometry.spherical.computeArea(path) / 1000000;
            var length =
              google.maps.geometry.spherical.computeLength(path) / 1000;
            polygon.getPath().forEach((latLng) => {
              arr.push({ lat: latLng.lat(), lng: latLng.lng() });
            });
            vm.showInfoWindowPolygon(arr, area, length);
          }
          getPath();
          this.selectedDrawing = "";
          google.maps.event.addListener(
            polygon.getPath(),
            "insert_at",
            getPath
          );
          google.maps.event.addListener(
            polygon.getPath(),
            "remove_at",
            getPath
          );
          google.maps.event.addListener(polygon.getPath(), "set_at", getPath);
          google.maps.event.addListener(polygon, "click", getPath);
        }
      );
    },
    drawCircle() {
      google.maps.event.addListener(
        this.drawingManager,
        "circlecomplete",
        (circle) => {
          this.showInfoWindowCircle(circle);
          this.selectedDrawing = "";
          google.maps.event.addListener(circle, "click", (e) => {
            this.showInfoWindowCircle(circle);
          });
          google.maps.event.addListener(circle, "radius_changed", () => {
            this.showInfoWindowCircle(circle);
          });
        }
      );
    },
    drawPolyLine() {
      google.maps.event.addListener(
        this.drawingManager,
        "polylinecomplete",
        (polyline) => {
          const vm = this;
          var arr = [];
          function getPath() {
            var path = polyline.getPath();
            var length =
              google.maps.geometry.spherical.computeLength(path) / 1000;
            polyline.getPath().forEach((latLng) => {
              arr.push({ lat: latLng.lat(), lng: latLng.lng() });
            });
            vm.showInfoWindowPolyline(arr, length);
          }
          getPath();
          this.selectedDrawing = "";
          google.maps.event.addListener(
            polyline.getPath(),
            "insert_at",
            getPath
          );
          google.maps.event.addListener(
            polyline.getPath(),
            "remove_at",
            getPath
          );
          google.maps.event.addListener(polyline.getPath(), "set_at", getPath);
          google.maps.event.addListener(polyline, "click", getPath);
        }
      );
    },
    drawRectangle() {
      google.maps.event.addListener(
        this.drawingManager,
        "rectanglecomplete",
        (rectangle) => {
          this.showInfoWindowRectangel(rectangle);
          this.selectedDrawing = "";
          google.maps.event.addListener(rectangle, "click", (e) => {
            this.showInfoWindowRectangel(rectangle);
          });
          // Add an event listener on the rectangle.
          google.maps.event.addListener(rectangle, "bounds_changed", () => {
            this.showInfoWindowRectangel(rectangle);
          });
        }
      );
    },
    initDrawManager() {
      var polyOptions = {
        strokeWeight: 0,
        fillOpacity: 0.45,
        editable: true,
      };
      // Creates a drawing manager attached to the map that allows the user to draw
      // markers, lines, and shapes.
      this.drawingManager = new google.maps.drawing.DrawingManager({
        //drawingMode: google.maps.drawing.OverlayType.RECTANGLE,
        drawingControl: false,
        drawingControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_RIGHT,
          drawingModes: [
            google.maps.drawing.OverlayType.MARKER,
            google.maps.drawing.OverlayType.CIRCLE,
            google.maps.drawing.OverlayType.POLYGON,
            google.maps.drawing.OverlayType.POLYLINE,
            google.maps.drawing.OverlayType.RECTANGLE,
          ],
        },
        markerOptions: {
          draggable: true,
        },
        polylineOptions: {
          editable: true,
        },
        rectangleOptions: polyOptions,
        circleOptions: polyOptions,
        polygonOptions: polyOptions,
        map: this.map,
      });

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        (e) => {
          // Switch back to non-drawing mode after drawing a shape.
          this.drawingManager.setDrawingMode(null);

          if (e.type != google.maps.drawing.OverlayType.MARKER) {
            var newShape = e.overlay;
            newShape.type = e.type;

            google.maps.event.addListener(newShape, "click", (e) => {
              this.setSelection(newShape);
            });
            this.setSelection(newShape);
          }
          console.log("Draw Success ....");
        }
      );

      google.maps.event.addListener(
        this.drawingManager,
        "polygoncomplete",
        (polygon) => {
          google.maps.event.addListener(polygon, "click", (e) => {
            var arr = [];
            polygon.getPath().forEach((latLng) => {
              arr.push(latLng.toString());
            });
            alert(arr.join(",\n"));
          });
          console.log("Poligon");
        }
      );

      google.maps.event.addListener(
        this.drawingManager,
        "circlecomplete",
        (circle) => {
          google.maps.event.addListener(circle, "click", (e) => {
            alert(circle.getCenter() + " : " + circle.getRadius());
          });
          console.log("Crlcle");
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "markercomplete",
        (marker) => {
          google.maps.event.addListener(marker, "click", (e) => {
            alert(marker.getPosition());
          });
          console.log("Marker");
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "polylinecomplete",
        (polyline) => {
          google.maps.event.addListener(polyline, "click", (e) => {
            var arr = [];
            polyline.getPath().forEach((latLng) => {
              arr.push(latLng.toString());
            });
            alert(arr.join(",\n"));
          });
          console.log("Line");
        }
      );
      google.maps.event.addListener(
        this.drawingManager,
        "rectanglecomplete",
        (rectangle) => {
          google.maps.event.addListener(rectangle, "click", (e) => {
            alert(rectangle.getBounds());
          });
          console.log("Rectangel");
        }
      );

      // Clear the current selection when the drawing mode is changed, or when the
      // map is clicked.
      google.maps.event.addListener(
        this.drawingManager,
        "drawingmode_changed",
        this.clearSelection
      );
      google.maps.event.addListener(this.map, "click", this.clearSelection);
      google.maps.event.addDomListener(
        document.getElementById("delete-button"),
        "click",
        this.deleteSelectedShape
      );
    },
    showArrays(event) {
      // Since this polygon has only one path, we can call getPath() to return the
      // MVCArray of LatLngs.
      var vertices = this.getPath();

      var contentString =
        "<b>Bermuda Triangle polygon</b><br>" +
        "Clicked location: <br>" +
        event.latLng.lat() +
        "," +
        event.latLng.lng() +
        "<br>";

      // Iterate over the vertices.
      for (var i = 0; i < vertices.getLength(); i++) {
        var xy = vertices.getAt(i);
        contentString +=
          "<br>" + "Coordinate " + i + ":<br>" + xy.lat() + "," + xy.lng();
      }

      // Replace the info window's content and position.
      this.infoWindow.setContent(contentString);
      this.infoWindow.setPosition(event.latLng);

      this.infoWindow.open(this.map);
    },
    clearMarkers(name = "all") {
      for (let i = 0; i < this.markers.length; i++) {
        if (name == "all") {
          this.markers[i].setMap(null);
        } else if (this.markers[i].name != "excise") {
          this.markers[i].setMap(null);
          this.markers.splice(i, 1);
        }
      }
      if (name == "all") {
        this.markers = [];
        this.markerClusterer.clearMarkers();
        for (let i = 0; i < this.circleMarker.length; i++) {
          this.circleMarker[i].setMap(null);
        }
        this.circleMarker = [];
      }
    },
    onCloseHistory() {
      console.log(this.vesselThm);
      // if (this.vesselThm) {
      this.clearMarkers();
      this.showMarkers();
      this.vesselThm = undefined;
      // }
      this.clearLineMarker();
    },
    clearLineMarker() {
      if (this.polyline) {
        this.polyline.setMap(null);
        this.polyline = undefined;
        // show default Tanker
      }
      for (let i = 0; i < this.dotMarket.length; i++) {
        this.dotMarket[i].setMap(null);
      }
      this.dotMarket = [];
    },
    onLoadHistory(flag) {
      if (flag) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    searchVesselHistory(vessels, val) {
      // = searchVesselHistory = //
      this.clearMarkers();
      if (!vessels[0].url) {
        this.vesselThm = vessels[0];
        const marker = this.createMarker(this.vesselThm);
        this.markers.push(marker);
      } else {
        this.clearLineMarker();
      }
      const urlReport = vessels[0].url;
      // get position
      if (urlReport) {
        const url = `${API_BASE_URL}${urlReport}`;
        const interval = val;
        axios
          .get(url, {
            headers: {
              "X-User-Email": this.accessEmail,
              "X-User-Token": this.accessToken,
            },
            params: {
              interval,
            },
          })
          .then((response) => {
            this.clearMarkers();
            const { position_reports } = response.data;
            this.vesselHistoryData = position_reports;
            const posData = {
              id: "-",
              ...position_reports[0],
              ...response.data,
            };
            this.drawVesselHistory(posData, this.vesselThm);
            this.drawPosition(position_reports, this.vesselThm);

            const tankers = this.dataVessel.filter(
              (val) => val.icon_type.toLowerCase() == "excise"
            );
            this.drawTanker(tankers);
          })
          .catch((error) => {
            console.log("Error call apis :", error);
          });
      }
    },
    drawTanker(tankers) {
      tankers.map((tanker) => {
        const position = new google.maps.LatLng(
          tanker.latitude,
          tanker.longitude
        );
        const img = this.getVesselImg(tanker);
        const markerImage = this.createMarkerIcon(img, 30);
        const marker = new google.maps.Marker({
          position,
          map: this.map,
          icon: markerImage,
          zIndex: 999,
          name: "excise",
        });

        const circle = new google.maps.Circle({
          strokeColor: "#C0C0C0",
          strokeOpacity: 0.6,
          strokeWeight: 1,
          fillColor: "#C0C0C0",
          fillOpacity: 0.6,
          map: this.map,
          center: position,
          radius: 8000,
          zIndex: 990,
        });
        this.circleMarker.push(circle);
        const fn1 = this.markerOnMouseMoveBaseStatus(tanker, position);

        const fn2 = this.markerClickFunction2(tanker, position);
        google.maps.event.addListener(marker, "mouseover", fn1);
        google.maps.event.addListener(marker, "click", fn2);
        this.markers.push(marker);
      });
    },
    drawVesselHistory(data, vessel, flag = true) {
      const { latitude, longitude } = data;
      const tanker = {
        ...vessel,
        ...data,
        hdg_cog: data.true_heading,
      };
      const position = new google.maps.LatLng(latitude, longitude);
      const img = this.getVesselImg(tanker);
      const markerImage = this.createMarkerIcon(img, 30);
      const marker = new google.maps.Marker({
        position,
        map: this.map,
        icon: markerImage,
        zIndex: 999,
      });
      this.markers.push(marker);
      this.map.panTo(position);
      const fn1 = this.markerClickFunction1(tanker, position);
      const fn2 = this.markerClickFunction2(tanker, position);
      const fn3 = this.markerClickFunction3(tanker, position);
      google.maps.event.addListener(marker, "mouseover", fn1);
      google.maps.event.addListener(marker, "click", fn2);
      google.maps.event.addListener(marker, "mouseout", fn3);
      if (flag) {
        this.map.setZoom(14);
      }
    },
    drawPosition(data, vassel) {
      const coords = [];
      for (let i = 0; i < data.length; i++) {
        let filename = "dot";
        if (i == 0) {
          filename = "dot_green";
        } else if (i == data.length - 1) {
          filename = "dot_red";
        }
        const icon = this.createMarkerIcon(
          `/vesselIcon/icons/${filename}.png`,
          8
        );
        const position = this.createMakerDotPoint(data[i], icon, false);
        coords.push(position);
      }
      this.drawLine(coords);
    },
    createMakerDotPoint(data, markerImage) {
      const position = new google.maps.LatLng(data.latitude, data.longitude);
      const dotMarket = new google.maps.Marker({
        position,
        map: this.map,
        icon: markerImage,
      });
      const fn1 = this.markerClickFunction1(data, position);
      const fn3 = this.markerClickFunction3(data, position);
      google.maps.event.addListener(dotMarket, "mouseover", fn1);
      google.maps.event.addListener(dotMarket, "mouseout", fn3);
      this.dotMarket.push(dotMarket);
      return position;
    },
    drawLine(coords) {
      this.polyline = new google.maps.Polyline({
        path: coords,
        geodesic: true,
        strokeColor: "#000000",
        strokeOpacity: 1.0,
        strokeWeight: 3,
        zIndex: 992,
        icons: [
          {
            icon: {
              // path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW,
              path: "M-2 -2 L 0 2 L2 -2 Z",
              strokeColor: "#F00",
              fillColor: "#F00",
              fillOpacity: 1,
              strokeWeight: 1,
            },
            repeat: "50px",
          },
        ],
      });
      this.polyline.setMap(this.map);
    },
    onChangeValue(val) {
      this.onMoveVessel(val);
    },
    onMoveVessel(i) {
      const latlng = new google.maps.LatLng(
        this.vesselHistoryData[i].latitude,
        this.vesselHistoryData[i].longitude
      );
      this.clearMarkers("excise");
      this.drawVesselHistory(this.vesselHistoryData[i], this.vesselThm, false);
      this.map.panTo(latlng);
    },
    onFullScreen() {
      const element = this.$el.querySelector("#warp_map"); // .getDiv();
      if (element.requestFullscreen) {
        element.requestFullscreen().catch((error) => console.log(error));
      }
      if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      }
      if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      }
      this.showController = true;
      this.isFullScreen = true;
      const vm = this;
      document.addEventListener("fullscreenchange", () => {
        vm.isFullScreen = document.fullscreen;
      });
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
      this.showController = false;
    },
  },
};
</script>

<style lang="scss">
.map-info-window {
  color: #000;
}
#parentx {
  overflow: hidden;
  height: 500px;
  position: relative;
}

.header-sidebar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}
.scroll-area--listExcise {
  height: 100%;
  margin-bottom: 0px;
  margin-top: 0px;
}
.vs-sidebar--items {
  padding: 0px;
}

.divLatLng {
  position: fixed;
  top: 12%;
  width: 15%;
  font-weight: bold;
  color: #000000;
  text-shadow: 2px 2px #ffffff;
  padding: 8px;
  // opacity: 0.9;
}

#color-palette {
  width: 24px;
  height: 120px;
  top: 60%;
  margin-left: 20px;
  color: white;
}
.info {
  color: black;
}
.info-img {
  height: 200px;
  width: 250px;
  border-style: solid gray;
  border-radius: 10px;
}

.detail-sensor {
  background-color: linen;
  height: 240px;
  overflow-y: scroll;
  border: solid 1px;
  border-radius: 10px;
}
.detail-car {
  background-color: linen;
  height: 240px;
  overflow-y: scroll;
  border: solid 1px;
  border-radius: 10px;
}
.grid-col-border {
  background-color: #1268c7;
  color: white;
  // border-style: outset;
  // font-weight: bold;
  font-size: 16px;
  text-align: center;
}
.grid-col {
  background-color: rgb(62, 138, 252);
  color: white;
  /* border-style: inset; */
  font-size: 14px;
}
.custom-pin {
  height: 1em;
  line-height: 1;
  width: 1em;
  padding: 0.7em;
  text-align: center;
  cursor: pointer;
  color: white;
  background: black;
  position: absolute;
  border-radius: 0.5em;
  font-size: 1em;
  font-weight: bold;
  transition: all 500ms;
}

.color-button {
  width: 30px;
  height: 30px;
  font-size: 0;
  margin: 2px;
  float: right;
  cursor: pointer;
}

.header-sidebar-draw {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  h4 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    > button {
      margin-left: 10px;
    }
  }
}

.footer-sidebar-draw {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  > button {
    border: 0px solid rgba(0, 0, 0, 0) !important;
    border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
    border-radius: 0px !important;
  }
}

.table td {
  border-top: 0.3px solid gray;
}
table {
  border-collapse: collapse;
}

#map {
  padding-bottom: 51%;
  position: relative;
  margin-top: 70px;
  width: 100%;
}

#warp_map {
  width: 100%;
}

@media only screen and (max-width: 458px) {
  #map {
    height: 100%;
    position: relative;
    margin-top: 70px;
  }
}

.customizer-btn-drawingMap-user {
  position: fixed;
  top: 54%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 30000;
  color: white;
}
.customizer-btn-listExcise-user {
  position: fixed;
  top: 42%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 30000;
  color: white;
}

.customizer-btn-detailVessel {
  position: fixed;
  top: 73%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
  color: white;
}

.customizer-btn-listExcise {
  position: fixed;
  top: 54%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 30000;
  color: white;
}

.customizer-btn-drawingMap {
  position: fixed;
  top: 48%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 30000;
  color: white;
}
.customizer-btn-color-delete {
  position: fixed;
  margin-left: 9px;
  margin-bottom: 14px;
  bottom: 15;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  color: white;
}

@media screen and (min-width: 1024px) {
  .divDetail {
    position: fixed;
    bottom: 0;
    width: 100%;
  }
}
.vs-sidebar.vs-sidebar-parent {
  position: absolute;
  height: 0;
  top: 0;
}

#over_map {
  position: absolute;
  width: 100px;
  height: 100px;
  background-color: red;
  top: 10px;
  left: 10px;
  z-index: 9999;
}

.exitFullScreen {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px;
  margin: 5px;
  z-index: 10;
}
.mymap {
  // position: absolute;
  padding-bottom: 51%;
  position: relative;
  margin-top: 20px;
  width: 100%;
}
.flex-end {
  position: absolute;
  right: 0px;
  margin: 2px;
}
.excise-name {
  display: block;
  white-space: nowrap;
  width: 10em;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
